/* eslint-disable import/prefer-default-export */
import * as React from "react";
import { Icon } from "@components";

interface ReviewStarsProps {
  stars: number;
}

export function ReviewStars({ stars }: ReviewStarsProps) {
  const starCount = Math.round(stars);
  const reviewStars = new Array(5)
    .fill("star", 0, starCount)
    .fill("empty-star", starCount);
  return (
    <span className="flex">
      {reviewStars.map((starFilled, index) => (
        <Icon
          name={starFilled}
          className="text-base"
          size="inherit"
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        />
      ))}
    </span>
  );
}
